module.exports = __webpack_public_path__ + "images/patterns/dark/StripeDiagonal.cc30b2fa7d9b73cdae10.svg";